module.exports = "/images/tablet.dc85102f12baad5eb73a5829ff7c930b.svg";